module.exports = "<template> <pre class=\"multiline-content cm-s-default\" ref=preNode>\n    </pre> </template> ";